import baseRequest from "../_core/baseRequest";

export default {
    getCourierRequestList: params => {
        return baseRequest.post(`/courier-requests/list`, params);
    },

    createCourierRequest: params => {
        return baseRequest.post("/courier-requests", params);
    },
    updateCourierRequest: params => {
        return baseRequest.put(`/courier-requests/${params.id}`, params);
    },
    deleteCourierRequest: params => {
        return baseRequest.delete(`/courier-requests/${params.id}`);
    },
    exportCourierRequestsList: params => {
        return baseRequest.post("/courier-requests/export", params, true);
    },
    closeCourierRequest: params => {
        return baseRequest.put(`/courier-requests/${params.id}/close-request`, params);
    },
    getActiveCourierRequestBySubCompanyId: params => {
        return baseRequest.post(
            "/courier-requests/get-active-courier-request-by-sub-company-id",
            params
        );
    },
    listAvailableCourierRequestsByCourierId: params => {
        return baseRequest.post(
            "/courier-requests/list-available-courier-requests-by-courier-id",
            params
        );
    },
    linkCourierToCourierRequest: params => {
        return baseRequest.post("/courier-requests/link-courier-to-courier-request", params);
    },
    getCourierRequestCouriersByType: params => {
        return baseRequest.post(`/courier-requests/${params.id}/couriers`, {type: params.type});
    }
};
